<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'获取门票成功' | dealLanguage('Obtained tickets successfully')}}</page-header>
    <div class="center-wrapper">
      <div class="top-tip" v-if="language == 'zh'">您好，感谢您关注<span>{{detail.activityName}}</span>，本届展会采用展前“线上实名预约登记”及现场核验“参会凭证”形式，请务必携带电子参会凭证或打印版参会凭证参会</div>
      <div class="top-tip" v-if="language == 'en'">Hello, thank you for following the <span>{{detail.activityEnName}}</span>,This exhibition adopts the form of "online reservation registration" before the exhibition and on-site verification of "attendance vouchers". Please be sure to bring electronic attendance vouchers or printed attendance vouchers to attend.</div>
      <div class="wrapper-container">
        <div class="view-title">
          <div class="title">{{'电子门票' | dealLanguage('Electronic tickets')}}</div>
          <div class="line"></div>
          <Button type="primary" @click="saveCode">{{'下载电子门票' | dealLanguage('Download')}}</Button>
        </div>
        <div class="ticket-view">
          <ticket-code ref="ticket-code"></ticket-code>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import ticketCode from '@/components/common/ticketCode.vue'
import { signdetail } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('获取门票成功', 'Obtained tickets successfully'),
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
    ticketCode,
  },
  created() {},
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('获取门票成功-2025VBEF大会', 'Obtained tickets successfully-2025VBEF Conference'),
      linkurl: this.vbef_path + '/ticketDetail/' + this.$route.params.id,
      
    })
    this.getDetail()
  },
  data() {
    return {
      page: 1,
      myticket: [],
      isMore: false,
      detail: {},
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {
    async getDetail() {
      let res = await signdetail({
        ticketUserRelationId: this.$route.params.id,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'detail', res.data)
        this.$nextTick(() => {
          this.$refs['ticket-code'].setImg(res.data)
        })
      } else {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    saveCode() {
      this.$refs['ticket-code'].saveCode()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
.center-wrapper
  padding 0.3rem 0.4rem 0.6rem
  .top-tip
    font-size 0.26rem
    color #3D3D3D
    line-height 0.42rem
    text-align justify
    span
      color #FF8824
  .view-title
    margin-bottom 18px
    .ivu-btn-primary
      color #fff
      background-color #FF8824
      border-color #FF8824
      box-shadow none
      max-width 1.9rem
      min-width 1.9rem
      width 1.9rem
      height 0.57rem
      font-size 0.26rem
      padding 0
      margin-left 0.15rem
  .wrapper-container
    margin-top 0.3rem
    .ticket-view
      width 100%
</style>